export default __webpack_public_path__ + "static/media/North_Fire_final.53fa69a0.mp3";